import { Box, Skeleton, Stack, Avatar } from '@mui/material';
import { Container } from '../../../components/container';

export const ClusterFormSkeleton = () => (
  <Container>
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="text" sx={{ fontSize: '2.125rem' }} width="40%" />
      </Stack>
    </Box>

    <Box sx={{ mt: 3 }}>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Skeleton variant="text" sx={{ fontSize: '1.25rem', mx: 'auto' }} width="60%" />
        <Skeleton variant="text" sx={{ fontSize: '1.25rem', mx: 'auto', mt: 1 }} width="40%" />
      </Box>

      <Box
        sx={{
          maxWidth: 600,
          mx: 'auto',
          p: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
          <Avatar
            sx={{
              bgcolor: 'grey.300',
              mr: 2,
              width: 48,
              height: 48,
            }}
          >
            <Skeleton variant="circular" width={24} height={24} />
          </Avatar>
          <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} width="70%" />
        </Box>

        <Stack spacing={3}>
          <Box>
            <Skeleton variant="text" width="30%" sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: 2 }} />
            <Skeleton variant="text" width="50%" sx={{ mt: 0.5, fontSize: '0.875rem' }} />
          </Box>

          <Stack direction="row" spacing={2} sx={{ pt: 2 }}>
            <Skeleton
              variant="rectangular"
              sx={{
                flex: 1,
                height: 48,
                borderRadius: 2,
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                flex: 1,
                height: 48,
                borderRadius: 2,
              }}
            />
          </Stack>
        </Stack>
      </Box>
    </Box>
  </Container>
);
